
const breakpoint = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '480px',
  tabletS: '565px',
  tabletM: '768px',
  tablet: '1024px',
  laptopS: '1280px',
  laptopL: '1440px',
  desktop: '2560px'
};

export const device = {
  mobileS: `max-width: ${breakpoint.mobileS}`,
  mobileM: `max-width: ${breakpoint.mobileM}`,
  mobileL: `max-width: ${breakpoint.mobileL}`,
  tabletS: `max-width: ${breakpoint.tabletS}`,
  tabletM: `max-width: ${breakpoint.tabletM}`,
  tablet: `max-width: ${breakpoint.tablet}`,
  laptopS: `max-width: ${breakpoint.laptopS}`,
  laptopL: `max-width: ${breakpoint.laptopL}`,
  desktop: `max-width: ${breakpoint.desktop}`,
  desktopL: `max-width: ${breakpoint.desktop}`
};
